import { useEffect, useState } from 'react';
import {
  getReviews,
  updateReview,
  deleteReview,
  isMissingTable,
} from '../services/adminApi';
import DataTable from '../components/DataTable';
import StatusBadge from '../components/StatusBadge';
import ConfirmDialog from '../components/ConfirmDialog';
import MissingTable from '../components/MissingTable';

export default function Reviews() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const load = async () => {
    const { data, error } = await getReviews();
    setRows(data);
    setError(error);
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  if (error && isMissingTable(error)) return <MissingTable table="reviews" />;

  const setStatus = async (row, status) => {
    setRows((prev) => prev.map((r) => (r.id === row.id ? { ...r, status } : r)));
    const { error } = await updateReview(row.id, { status });
    if (error) {
      alert(`Update failed: ${error.message}`);
      load();
    }
  };

  const handleDelete = async () => {
    setDeleting(true);
    const { error } = await deleteReview(deleteTarget.id);
    setDeleting(false);
    setDeleteTarget(null);
    if (error) alert(`Delete failed: ${error.message}`);
    load();
  };

  return (
    <div>
      <div className="page-head">
        <h1>Reviews</h1>
      </div>

      {error && !isMissingTable(error) && (
        <p className="admin-error">Failed to load: {error.message}</p>
      )}

      <DataTable
        loading={loading}
        emptyMessage="No reviews submitted yet."
        columns={[
          {
            key: 'customer_name',
            label: 'Customer',
            render: (r) => r.customer_name || '—',
          },
          {
            key: 'product_name',
            label: 'Product',
            render: (r) => r.product_name || '—',
          },
          {
            key: 'rating',
            label: 'Rating',
            render: (r) => '⭐'.repeat(Number(r.rating) || 0) || '—',
          },
          {
            key: 'comment',
            label: 'Review',
            render: (r) => <span className="review-text">{r.comment || '—'}</span>,
          },
          {
            key: 'status',
            label: 'Status',
            render: (r) => <StatusBadge status={r.status || 'pending'} />,
          },
          {
            key: 'actions',
            label: 'Actions',
            width: '220px',
            render: (r) => (
              <div className="action-buttons">
                {r.status !== 'approved' && (
                  <button className="btn-edit" onClick={() => setStatus(r, 'approved')}>
                    Approve
                  </button>
                )}
                {r.status !== 'rejected' && (
                  <button className="btn-view" onClick={() => setStatus(r, 'rejected')}>
                    Reject
                  </button>
                )}
                <button className="btn-delete" onClick={() => setDeleteTarget(r)}>
                  Delete
                </button>
              </div>
            ),
          },
        ]}
        rows={rows}
      />

      <ConfirmDialog
        open={!!deleteTarget}
        title="Delete review?"
        message="This review will be permanently removed."
        confirmLabel="Delete"
        busy={deleting}
        onConfirm={handleDelete}
        onCancel={() => setDeleteTarget(null)}
      />
    </div>
  );
}
